import { ButtonColor, ButtonTextColorMap } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { useState } from "react";
import { CloseOutlineIcon } from "../icon/CloseOutlineIcon";
import { Body14Regular } from "../typography/Body14Regular";

interface Props {
  handleClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const ImageCarouselDeleteButton: React.FC<Props> = ({ handleClick }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <Button
      color={ButtonColor.RED}
      size="xs"
      onClick={handleClick}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <div className="flex items-center gap-[8px]">
        <CloseOutlineIcon
          size={16}
          color={isFocused ? "text-white" : ButtonTextColorMap[ButtonColor.RED]}
        />
      </div>
      <Body14Regular>사진 삭제하기</Body14Regular>
    </Button>
  );
};
